export class FormUserModel {
    name: string = "";
    id: string = "";
    broker: string = "";
    intermediaryNumber: string = "";
}
